import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import ResultView from "./ResultViewComponent";
import { jobAlertUnsubscribe } from "../../../redux/slices/careersSlices.reducer";
import { careersMessages } from "../../../config/careers/careers";
import { toast } from "react-toastify";
import { clientIds } from "../../../config/clients/clients";
import Image from "../../../component/image/Image";
import zealLogo from "../../../assets/images/clients/zeal-logo.png";
import useClientConfig from "../../../config/careers/clientConfig";

const JobAlertUnSubscribe = (props: any) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pageParams = useParams();
    const settingsLoaded = useSelector((state: any) => state.careers.settingsLoaded);
    const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
    const cancellationStatus = useSelector((state: any) => state.careers.subscriptionCancellation);
    const {clientSiteSettings} = useClientConfig();

    const [apiLoad, setApiLoad] = useState(false);
    const [cancellationStatusResult, setCancellationStatusResult] = useState<string>("");
    const [cancellationMessage, setCancellationMessage] = useState<string>("");
    const [subscriptionToken, setSubscriptionToken] = useState<string>("");

    useEffect(() => {
        if(pageParams?.token) {
            setSubscriptionToken(pageParams?.token);
        }
        else{
            //TODO : insert redirect to 404 or listings
        }
    }, [location.pathname]);

    //Ensures preloaded api data is present or done loading, this prevents multiple calls on useEffect
    useEffect(() => {
        if(settingsLoaded === true) {
            setApiLoad(true);
        } else {
            setApiLoad(false);
        }
    }, [settingsLoaded]);

    useEffect(()=>{
        if(apiLoad === true) {            
            dispatch<any>(jobAlertUnsubscribe(subscriptionToken));
        }
    }, [subscriptionToken]);

    useEffect(() => {
        if(apiLoad === true) {
            let verificationAPIResponse = cancellationStatus?.data;
            setCancellationStatusResult(verificationAPIResponse?.statusCode);
            if (verificationAPIResponse.statusCode === 200) {
                setCancellationMessage(verificationAPIResponse?.result);
            }
            else if (verificationAPIResponse.statusCode === 400) {
                setCancellationMessage(verificationAPIResponse?.result);
            }
            else {
                toast(careersMessages.apiErrorMessage, {
                    type: "error",
                    autoClose: 60000,
                });
            }
        }
    }, [cancellationStatus]);

    const redirectListing = () => {
        navigate("/");
    };

    return(
        <>
            <div className= "container-fluid subheader-3">
              <div className="row">
                <div className="col-md-6 col-lg-6 col-12 col-sm-12  ">
                  <div className="d-none d-sm-none d-md-block">
                    <p className="page-heading mb-0 page-heading-img">
                      {
                        (clientSiteSettings?.templateName === "template_4") ?
                        <>
                          <button onClick={redirectListing}>
                            <Image src={zealLogo} alt="Zeal Logo" />
                          </button>
                        </>
                        : ""
                      }
                      Job Alerts
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <ResultView 
                result={cancellationStatusResult}
                message={cancellationMessage}
            />
        </>
    );
};

export default JobAlertUnSubscribe;